import SBEditable from "../../../components/sbEditable/sbEditable";
import ListingHeader from "../../../components/listingHeader/listingHeader";
import ArticleAsideCard from "../../../components/articleAsideCard/ArticleAsideCard";

import { useStoryblokCuratedArticlesWidget } from "../../../hooks/useStoryblokCuratedArticlesWidget";

import styles from "./articleListingCuratedWidget.module.scss";

/// >> Blok:articlelistingwidget
// headline:text
// articles:multiselect
function ArticleListingWidget({ blok }) {
  const [articleList, isLoading] = useStoryblokCuratedArticlesWidget(blok.articles);

  if (!isLoading && articleList.length === 0) {
    return null
  }

  return (
    <SBEditable blok={blok}>
      <ListingHeader>
        <h3>{blok.headline}</h3>
      </ListingHeader>
      <ul className={styles.wrapper}>
        {articleList.map((article, idx) => {
          return (
            <li key={article.uuid}>
              <ArticleAsideCard
                slug={article.slug}
                thumbnail={article.content.thumbnail}
                authors={article.content.authors}
                title={article.content.headline}
                date={article.content.created_at}
                article_category={article.content.category}
                article_type={article.content.article_type}
                comment_count={5}
                enable_comments={article.content.has_comments}
                enable_social_sharing={article.content.has_social_sharing}
              />
              {idx < articleList.length - 1 ? <hr /> : null}
            </li>
          );
        })}
      </ul>
    </SBEditable>
  );
}

export default ArticleListingWidget;
